import useLiveSanityContent, {
  UseLiveSanityContentResponse
} from "../../utils/useLiveSanityContent";
import { RemoteShorexModalContent } from "./type";

export const useRemoteShorexModalContent = (
  shorexId: number
): UseLiveSanityContentResponse<RemoteShorexModalContent> => {
  const query = `
    *[_type == "shorex" && shorexId==${shorexId}]
    {
      _key,
      activityLevel,
      category,
      accessibility,
      code,
      features,
      name,
      shorexId,
      descriptionHtml,
      noteHtml,
      image{
        asset->{
          _id,
          assetId,
          url,
          extension,
          metadata{dimensions}
        }
      }
    }[0]
  `;

  return useLiveSanityContent<RemoteShorexModalContent>(query);
};
